import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  IonButton,
  IonModal,
  IonHeader,
  IonContent,
  IonTitle,
  IonButtons,
  IonToolbar,
  IonList,
  IonText,
  IonItem,
  IonInput,
} from '@ionic/react';
import { Clipboard } from '@capacitor/clipboard';
import { useSelector } from 'react-redux';
import { AppSelectors } from 'redux/AppRedux';

function ShareModal({ open, onClose, venueId, ticketId }) {
  const [copied, setCopied] = useState(false);
  const venue = useSelector(AppSelectors.selectVenueDetail);
  const url = `https://pay.vemos.io/invite/${venueId}/${ticketId}?name=${venue.name}`;
  const handleCopy = () => {
    Clipboard.write({
      string: url,
    });

    setCopied(true);
    setTimeout(() => {
      setCopied(false);
    }, 3000);
  };

  return (
    <IonModal isOpen={open} onDidDismiss={onClose}>
      <IonHeader>
        <IonToolbar>
          <IonTitle>Invite to Vemos Pay</IonTitle>
          <IonButtons slot="end">
            <IonButton onClick={onClose} fill="light">
              Close
            </IonButton>
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <IonList className="ion-padding">
          <IonText className="center-flex-content mt-3x  mb-5x">
            <h2>Add Your Friends to This Tab!</h2>
            <p>
              Share this link with your friends so they can join this tab and
              split the bill with you.
            </p>
          </IonText>
          <IonItem lines="full">
            <IonInput value={url} readonly />
          </IonItem>
          <div className="mt-3x">
            <IonButton
              color="secondary"
              expand="block"
              fill="solid"
              onClick={handleCopy}
            >
              {copied ? 'Copied to Clipboard!' : 'Copy to Clipboard'}
            </IonButton>
          </div>
        </IonList>
      </IonContent>
    </IonModal>
  );
}

ShareModal.propTypes = {
  venueId: PropTypes.string,
  ticketId: PropTypes.string,
  open: PropTypes.bool,
  onClose: PropTypes.func,
};

export default ShareModal;
